require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")

import "bootstrap";

import{ initFlatPickr } from "../plugins/init_date_picker";
import { initSelect2 } from "../components/init_select2";
import { initOwlCarousel } from "../components/init_owl_carousel";
import { initToggleButtons } from "../components/init_toggle_buttons";
import { initPhotoUpload } from "../components/init_photo_upload";
import { initCommentButtons } from "../components/init_comment_buttons";
import { initExplainTable } from "../components/init_explain_table";
import { initMapbox } from "../plugins/init_mapbox";
import { initCardToggle } from "../components/init_card_toggle";
import { initProgressBar } from "../components/init_bar_progress";
// import { initCountdown } from "../components/init_countdown";
import { initAutocomplete } from "../plugins/init_autocomplete";
import { initAOS } from "../plugins/init_aos";
import { initUpdateNavbarOnScroll } from '../components/init_navbar';
import { initGoogleAutocomplete } from '../components/init_google_autocomplete';
import { initSpinner } from '../components/init_spinner';
import { initBackButton } from '../components/init_back_button';
import { initModalBanner } from '../components/init_modal_banner';
import { initSubmitCallButton } from "../components/init_submit_call_button";
import { initSidebar } from '../components/init_sidebar';
import { initPreventScrollOnNavbar } from '../components/init_navbar';
import { initSortUpcoming } from '../components/init_sort_upcoming';
import { initCharCountBuyerNotes } from "../components/init_char_count";
import { initRemoveChecked } from "../components/init_remove_checked";
import { initVinLookupToggle } from "../components/init_vin_lookup_toggle";

initSidebar();
initSelect2();
initToggleButtons();
initPhotoUpload();
initCommentButtons();
initExplainTable();
initOwlCarousel();
initMapbox();
initCardToggle();
initProgressBar();
// initCountdown(".timer-countdown-js");
initFlatPickr();
// initAutocomplete();
initAOS();
initUpdateNavbarOnScroll();
initGoogleAutocomplete();
initSpinner();
initBackButton();
initModalBanner();
initSubmitCallButton();
initPreventScrollOnNavbar();
initSortUpcoming();
initCharCountBuyerNotes();
initRemoveChecked();
initVinLookupToggle();
